
import Cookies from 'js-cookie';
import {Howl} from 'howler';

/**
 * @uses 遠隔点呼の件数や一覧の更新など画面上の変更を行うクラス
 */
export class RemoteRollcallViewer {

    msec = 1000;
    conditionCallback = null;
    remoteRollcallStandbyId = '';
    itRollcallStandbyId = '';
    status = false;
    timer = null;
    sound = null;

    constructor(msec, conditionCallback = null, autoAuthenticateCallback = null, remoteRollcallStandbyId = 'remote-rollcall-standby', itRollcallStandbyId = 'it-rollcall-standby') {
        this.msec = msec;
        this.conditionCallback = conditionCallback;
        this.autoAuthenticateCallback = autoAuthenticateCallback;
        this.remoteRollcallStandbyId = remoteRollcallStandbyId;
        this.itRollcallStandbyId = itRollcallStandbyId;
        // 遠隔/ITの受付がいずれかが有効化されているか
        this.status = ($(create_id(remoteRollcallStandbyId)).length != 0 && $(create_id(remoteRollcallStandbyId)).prop('checked')) || ($(create_id(itRollcallStandbyId)).length != 0 && $(create_id(itRollcallStandbyId)).prop('checked'));
        this.reset();
        this.set();
    }

    reset() {
        Cookies.set('remote_rollcall_displayed', '');
        Cookies.set('toastr_collectable_displayed', '1');
    }

    set() {

        const self = this;
        const remoteRollcallStandbyId = this.remoteRollcallStandbyId;
        const itRollcallStandbyId = this.itRollcallStandbyId;

        // 受付有効時
        if (this.status) {
            // 待機取得処理を指定間隔で実行
            this.timer = setInterval(function(obj) {
                obj.waitUpdate(obj);
            }, this.msec, this);
        } else {
            // 無効時は初期化
            (this.timer != null) && clearInterval(this.timer);
        }

        // IT/遠隔点呼受付フラグ変更時
        $(document).on('change', '#' + remoteRollcallStandbyId + ', #' + itRollcallStandbyId, function() {
            // 有効判定フラグ
            const isEnable = $(this).prop('checked');
            // エレメントID
            const id = $(this).attr('id');
            // IT点呼受付操作判定
            const isIt = ($('#' + remoteRollcallStandbyId + '-actions').data('it_type') == $(this).data('type'));
            // 有効/無効切り替えPost先URL
            var action = $('#' + remoteRollcallStandbyId + '-actions').data('remote-standby-action');
            // 遠隔/IT点呼一覧URL
            var list = $('#' + remoteRollcallStandbyId + '-actions').data('remote-list-action');
            // IT点呼の場合
            if (isIt) {
                // Post先と一覧URLを変更
                action = $('#' + remoteRollcallStandbyId + '-actions').data('it-standby-action');
                list = $('#' + remoteRollcallStandbyId + '-actions').data('it-list-action');
                if ($('#' + remoteRollcallStandbyId).prop('checked')) {
                    list = $('#' + remoteRollcallStandbyId + '-actions').data('remote-list-action');
                }
            }
            // 有効/無効の切り替えをPost
            _ajax.post(action, {'is_enable': isEnable}, function (results) {
                // 有効化時は一覧に遷移し終了
                if (isEnable) {
                    location.href = list;
                    return;
                }
                // 無効化時
                if (!$('#' + remoteRollcallStandbyId).prop('checked') && !$('#' + itRollcallStandbyId).prop('checked')) {
                    // ダッシュボードへ
                    location.href = $('#' + remoteRollcallStandbyId + '-actions').data('dashboard-action');
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        });

        // 遠隔/IT点呼のアクション指定が行われている場合
        if ($('#' + remoteRollcallStandbyId + '-actions').length > 0) {
            const remoteSwitchId = $('#' + remoteRollcallStandbyId + '-actions').data('remote-rollcall-switch-id');
            const itSwitchId = $('#' + remoteRollcallStandbyId + '-actions').data('it-rollcall-switch-id');
            // 再ログインによる継続/スイッチ自体がONになっていない
            if ($('#' + remoteRollcallStandbyId + '-actions').data('remote-rollcall-continued') &&
               (!$('#' + remoteSwitchId).prop('checked'))) {
                console.log('1: 遠隔点呼自動ログインの開始');
                // カメラを起動させるため1秒ディレイ
                setTimeout(function() {
                    // スタンバイ中に変更するためにフラグを付与
                    $('#remote_rollcall-recognition-modal').data('is_standby', true);
                    // ITも必要な場合
                    if ($('#' + remoteRollcallStandbyId + '-actions').data('it-rollcall-continued') &&
                        !$('#' + itSwitchId).prop('checked')) {
                        $('#remote_rollcall-recognition-modal').data('with_it_rollcall', true);
                    }
                    console.log('2: 顔認証モーダルの表示');
                    // 認証画面を表示
                    _modal.show('#remote_rollcall-recognition-modal');
                    // 認証開始時のコールバックを呼出
                    if (self.autoAuthenticateCallback != null) {
                        console.log('3: 自動認証のコールバックを実行');
                        self.autoAuthenticateCallback();
                    }
                }, 1000);
            // IT点呼のみ
            } else if ($('#' + remoteRollcallStandbyId + '-actions').data('it-rollcall-continued') && !$('#' + itSwitchId).prop('checked')) {
                console.log('IT: IT点呼自動ログインの開始');
                // クリックで実行
                $('#' + itSwitchId).trigger('click');
            }
        }
        

        // トースト用メニューのトグルボタン操作時
        $(document).on('click', '#remote_rollcall-toastr-toggle-button', function() {
            const isCollectableDisplayed = $(this).attr('aria-expanded') == 'false';
            const target = isCollectableDisplayed ? 'remote-rollcall-toastr-overlap' : 'remote-rollcall-toastr-not-overlap';
            const update = !isCollectableDisplayed ? 'remote-rollcall-toastr-overlap' : 'remote-rollcall-toastr-not-overlap';
            $('.' + target).toggleClass(update, true).removeClass(target);
            $(this).attr('aria-expanded', isCollectableDisplayed ? 'true' : 'false');
            Cookies.set('toastr_collectable_displayed', !isCollectableDisplayed ? '1' : '0');
        });
        // トースト用メニューの削除ボタン操作時
        $(document).on('click', '#remote_rollcall-toastr-delete-button', this, function(e) {
            const obj = e.data;
            // 閉じた点呼のID
            let closed = ((Cookies.get('remote_rollcall_closed') === undefined) ? '': Cookies.get('remote_rollcall_closed')).split(',');
            $('.remote-rollcall-toastr-item').each(function() {
                const confirm = String($(this).data('id'));
                closed.push(confirm);
            });
            obj.stop();
            Cookies.set('remote_rollcall_closed', closed.join(','));
        });
    }

    waitUpdate(obj = null) {
        obj = (obj == null) ? this : obj;
        const remoteRollcallStandbyId = obj.remoteRollcallStandbyId;
        if (obj.conditionCallback == null || !obj.conditionCallback()) {
            return;
        }
        let action = $('#remote-rollcall-navbar-menu').data('action');
        _ajax.background(action, {}, function(results, obj) {
            $('#remote-rollcall-notification-count').text(results.models.length);
            $('#remote-rollcall-notification-count').toggleClass('display-none', !(results.models.length > 0));
            // 閉じた点呼のID
            let closed = ((Cookies.get('remote_rollcall_closed') === undefined) ? '': Cookies.get('remote_rollcall_closed')).split(',');
            // 表示ずみの点呼ID
            let displayed = ((Cookies.get('remote_rollcall_displayed') === undefined) ? '': Cookies.get('remote_rollcall_displayed')).split(',');
            // 重ね表示機能の判定フラグ
            let collectableDisplayed = Number(((Cookies.get('toastr_collectable_displayed') === undefined) ? '1': Cookies.get('toastr_collectable_displayed')));
            // 再読み込みフラグ
            let reload = false;
            // 待機項目が存在しない場合は通知を停止
            if (results.models.length == 0) {
                obj.stop();
            } else {

                let models = results.models.reverse();

                // 待機項目分繰り返し
                $.each(models, function(index, value) {
                    // 表示を継続するか
                    let isExtened = false;
                    // 確認用ID
                    const confirm = String(value.id) + String(Date.parse(value.created_at));
                    // 表示済み項目の場合
                    if (displayed.indexOf(confirm) >= 0) {
                        isExtened = true;
                    }
                    // 継続しない場合
                    if (!isExtened) {
                        // 削除
                        $('#remote-rollcall-toastr-item_' + confirm).parents('.toast-info').remove();
                        // ステータスの更新のため一覧を更新する
                        reload = true;
                    }
                    // 表示した・閉じた項目に含まれる場合は何もしない
                    if (closed.indexOf(confirm) >= 0 || displayed.indexOf(confirm) >= 0) {
                        return;
                    }
                    // 表示されていない項目があるため更新
                    reload = true;
                    // 表示済み項目に追加
                    displayed.push(confirm);
                    Cookies.set('remote_rollcall_displayed', displayed.join(','));

                    // トースト判定用の隠し値
                    let hiddenItem = '<span id="remote-rollcall-toastr-item_' + confirm + '" class="remote-rollcall-toastr-item display:none;" data-id="' + confirm + '"></span>';
                    toastr.info(value.notice + hiddenItem, '', {
                        'timeOut': 0,
                        'extendedTimeOut': 0,
                        'closeButton': true,
                        'toastClass': collectableDisplayed ? 'remote-rollcall-toastr-overlap' : 'remote-rollcall-toastr-not-overlap',
                        'positionClass': 'toast-top-full-width',
                        'preventDuplicates': true,
                        'onclick': function() {
                            if (value.method_type == $('#' + remoteRollcallStandbyId + '-actions').data('it_type')) {
                                obj.authorizerSelect(value.meeting_id);
                            } else {
                                $('#remote_rollcall-recognition-modal').data('meeting_id', value.meeting_id);
                                $('#remote_rollcall-recognition-modal').modal('show');
                            }
                        },
                        'onCloseClick': function() {
                            closed.push(confirm);
                            Cookies.set('remote_rollcall_closed', closed.join(','));
                        },
                        'onShown': function() {
                            $(this).css({
                                'z-index': 10000 + Number(value.id)
                            });
                        }
                    });
                });
            }
            $('#remote_rollcall-toastr-toggle-button').attr('aria-expanded', collectableDisplayed ? 'false' : 'true');
            // 表示項目の状態に応じて音声を再生停止
            ($('.remote-rollcall-toastr-item').length > 0) ? obj.play() : obj.stop();
            // 複数件存在している場合
            if ($('.remote-rollcall-toastr-item').length > 1) {
                $('#remote_rollcall-toastr-toggle-button .remote_rollcall-toastr-count').html($('.remote-rollcall-toastr-item').length);
                $('#remote_rollcall-toastr-action').toggleClass('d-none', false);
            } else {
                $('#remote_rollcall-toastr-action').toggleClass('d-none', true);
            }
            // 更新が必要な場合は更新
            if ((is_route('remote_rollcall.index') || is_route('it_rollcall.index')) && reload) {
                obj.listUpdate();
            }
        }, function(xhr, status, errorThrown, obj){
            (obj.timer != null) && clearInterval(obj.timer);
            obj.stop();
            _error.omitted(xhr, status, errorThrown);
        }, 'json', obj);

    }

    listUpdate() {
        let action = '';
        let datas = [];
        if (!$('#search-form input[name=' + $('#toolbar-keyword-search').attr('name') + ']').length) {
            $('#search-form').append($('<input></input>', {
                type: 'hidden',
                name: $('#toolbar-keyword-search').attr('name'),
                value: $('#toolbar-keyword-search').val(),
            }));
        }
        $('#search-form input[name=' + $('#toolbar-keyword-search').attr('name') + ']').val($('#toolbar-keyword-search').val());
        // 検索フォームの値をURLにセットする
        _request.set_parameters($('#search-form').serializeArray());
        // 現在のURLのGetパラメーターを引き継ぐ
        action = $('#search-form').attr('action');
        action = extend_url_query(action);
        $('#search-form').attr('action', action);
        datas = $('#search-form').serializeArray();
        datas.push({
            'name': 'load_type',
            'value': 'json',
        });
        // 表示済みの項目のIDを取得
        var ids = [];
        $('#remote_rollcall-list-area tbody tr').each(function(i, elm) {
            ids.push($(elm).attr('id'));
        });
        _ajax.background(action, datas, function (results) {
            let hasItem = (results.models.length != 0);
            // 表示エリアの切り替え
            $('#remote_rollcall-list-area').toggleClass('display-none', !hasItem);
            $('#remote_rollcall-not-found').toggleClass('display-none', hasItem);
            // ページネーターの更新
            $('#remote_rollcall-list-area .paginator').html(results.paginator);
            $.each(results.models.reverse(), function(index, value) {
                // 既存の項目は置き換え/新規は最終に追加
                if ($(create_id(value['id'])).length) {
                    $(create_id(value['id'])).replaceWith(value['view']);
                } else {
                    $('#remote_rollcall-item-list').prepend(value['view']);
                }
                // 表示したIDを削除
                ids = ids.filter(function(id) {
                    return id != value['id'];
                });
            });
            // 余ったものは削除
            $.each(ids, function(index, id) {
                $(create_id(id)).remove();
            });
        }, function(xhr, status, errorThrown){
            _error.set('#search-form', xhr, status, errorThrown);
        });

    }

    authorizerSelect(meetingId) {
        const modalId = create_id('it_rollcall-authorizer-modal');
        const datas = {'meeting_id': meetingId};
        const action = $('#' + this.remoteRollcallStandbyId + '-actions').data('authorizer-action');
        // モーダルにMeetingIdをdataでセット
        $(modalId).data('meeting_id', meetingId);
        // モーダルのコンテンツを空に
        $(modalId + ' .modal-content').empty();
        // 送信
        _ajax.post(action, datas, function (results) {
            $(modalId + ' .modal-content').html(results);
            initialize();
            _modal.show(modalId);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    static initializeDetailArea() {
        let drawer = {

            /*---- properties ----*/
            _popoverEl: '',  // popover要素
    
            /*---- 初期化 ----*/
            init: function() {
                // OPEN
                $(document).on('click', '#remote_rollcall-join-modal #drawer-open', function () {
                    drawer.toggle($('#remote_rollcall-join-modal #drawer-content').is(':hidden'));
                });
                // CLOSE
                $(document).on('click', '#remote_rollcall-join-modal #drawer-close', function () {
                    drawer.toggle($('#remote_rollcall-join-modal #drawer-content').is(':hidden'));
                });
                drawer.popover();
            },
    
            /*---- 表示制御 ----*/
            toggle: function(open) {
                let content = $('#remote_rollcall-join-modal #drawer-content');
                // escape when not selector
                if (content.length === 0) {
                    return;
                }
                let parent = content.parent('#remote_rollcall-join-modal #drawer-toggle');
                let joinBlock = $('#join-block');
                if (open) {
                    // open
                    $('#remote_rollcall-join-modal #drawer-open').addClass('d-none');
                    content.removeClass('d-none');
                    // parent.removeClass('col-auto').addClass('col-12 col-lg-2 col-md-4 col-sm-5').css({width: "unset"});
                    // joinBlock.addClass('col-12 col-lg-10 col-md-8 col-sm-7').removeClass('col-auto').css({width:"unset"});
                    parent.removeClass('col-auto').addClass('col-5').css({width: "unset"});
                    joinBlock.addClass('col-7').removeClass('col-auto').css({width:"unset"});
                } else {
                    // close
                    $('#remote_rollcall-join-modal #drawer-open').removeClass('d-none');
                    content.addClass('d-none');
                    // parent.addClass('col-auto').removeClass('col-12 col-lg-2 col-md-4 col-sm-5').css({width: "5%"});
                    // joinBlock.addClass('col-auto').removeClass('col-12 col-lg-10 col-md-8 col-sm-7').css({width:"95%"});
                    parent.addClass('col-auto').removeClass('col-5').css({width: "40px"});
                    joinBlock.addClass('col-auto').removeClass('col-7').css({width:"calc(100% - 40px)"});
                }
                drawer.popover();
                // timeline._calendar.render();
            },
    
            /*---- popover制御 ----*/
            popover: function() {
                drawer._popoverEl = $('.external-popover');
                if (drawer._popoverEl.length > 0) {
                    drawer._popoverEl.popover('dispose');
                    drawer._popoverEl.popover({
                        trigger: 'hover',
                        placement: 'top',
                        container: 'body',
                        html: true
                    });
                }
            },
        }
        // load
        drawer.init();
    }

    play() {
        if (this.sound == null) {
            this.sound = new Howl({
                src: '/assets/audio/call.mp3',
                loop: true,
            });
            this.sound.play();
        }
    }

    stop() {
        // toastを非表示にする
        $('.remote-rollcall-toastr-item').each(function() {
            $(this).parents('.toast-info').remove();
        });
        // トーストメニューを非表示にする
        $('#remote_rollcall-toastr-action').toggleClass('d-none', true);
        // サウンドを停止
        if (this.sound != null) {
            this.sound.stop();
            this.sound = null;
        }
    }
}